import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { iframeDataBridge } from '@/iframe/iframeDataBridge';

const STORAGE_PREFIX = 'deliveryLocationFilters';

export const emptyFilters = () => ({
	organisations: [],
	excludeSharedOrganisations: false,
	type: [],
	account: [],
	channel: [],
	group: [],
	canal: [],
	posType: [],
	postalCode: [],
	kpi: [],
	freshness: 0,
	seasonality: [],
	orderAssortMode: null,
	orderAssortDate: null,
	campaign: null,
	onlyMissing: false,
});

function storageKey() {
	return `${STORAGE_PREFIX}.${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}`;
}

function loadFromStorage() {
	try {
		const raw = localStorage.getItem(storageKey());
		return raw ? { ...emptyFilters(), ...JSON.parse(raw) } : emptyFilters();
	} catch {
		return emptyFilters();
	}
}

function saveToStorage(filters) {
	try {
		localStorage.setItem(storageKey(), JSON.stringify(filters));
	} catch {
		// ignore storage errors (e.g. private browsing)
	}
}

export const useFilterStore = defineStore('filter', () => {
	const filters = ref(loadFromStorage());

	const hasFilters = computed(() => Object.values(filters.value).some((value) => (Array.isArray(value) ? value.length > 0 : !!value)));

	function setFilters(newFilters) {
		filters.value = { ...emptyFilters(), ...newFilters };
		saveToStorage(filters.value);
	}

	function resetFilters() {
		filters.value = emptyFilters();
		saveToStorage(filters.value);
	}

	return { filters, hasFilters, setFilters, resetFilters };
});
